import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/user/auth'
import axios from 'axios'

export const useViewLoadingStore = defineStore({
   id: 'loading',
   state: () => ({
      isLoading: false,
      storeAuth: useAuthStore(),
   }),
   actions: {
      updateLoading(status) {
         this.isLoading = status
      }
   }
})